import { render, staticRenderFns } from "./LanguageDialog.vue?vue&type=template&id=a81ac38e&"
import script from "./LanguageDialog.vue?vue&type=script&lang=js&"
export * from "./LanguageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports